export enum InputType {
  Email = 'email',
  Number = 'number',
  Password = 'password',
  Text = 'text',
}
